export const matchProperties: Record<string, string> = {
  branch: 'branches',
  depot: 'depots',
  route: 'routes',
  vehicle: 'vehicles',
  gosNomer: 'gosNomer',
  routeType: 'transporttypes'
};
